<div class="mb-2">
  <fgbcl-errors></fgbcl-errors>
</div>

<button (click)="loginSeatGeek()" class="btn bg-primary text-white w-100 fw-bold">
  {{ 'login.button.seatgeek' | translate }}
</button>
